export default {
  add: 'Add',
  admin: 'Admin',
  allLoaded: 'Displaying all items',
  appName: 'TailTale',
  basic: 'Basic',
  cancel: 'Cancel',
  close: 'Close',
  create: 'Create',
  createWorkspace: 'Create Workspace',
  createWorkspaceWhy: 'Create a new workspace to group your teams under the same umbrella.',
  goBackHome: 'Go back home',
  edit: 'Edit',
  error: 'Error',
  loadMore: 'Load more...',
  login: 'Log in',
  logout: 'Log out',
  name: 'Name',
  none: 'None',
  remove: 'Remove',
  save: 'Save',
  search: 'Search',
  selectNone: 'Select None',
  selectedTeam: 'Selected Team',
  selectedWorkspace: 'Selected Workspace',
  teamNameExample: 'Product, Sales, etc.',
  update: 'Update',
  workspaceNameExample: 'Jira, Slack, etc.',
}
